import Icon from '../components/Icon.vue'

Icon.register({
  'eye-slash': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M286.7 392L319.3 438.5A334-334 0 0 0 288 440C168.2 440 63 376.1 6.6 280.4A48-48 0 0 0 6.6 231.6C30.7 190.9 63.6 155.9 102.7 129.1L159.7 210.6C154.7 224.8 152 240.1 152 256 152 330.7 212.1 391.3 286.7 392zM569.4 280.4C537.7 334.1 490.6 377.8 434.2 405.8L434.2 405.9 475.7 465.1C483.3 475.9 480.6 490.9 469.8 498.5L456.7 507.7C445.8 515.3 430.8 512.6 423.2 501.8L100.3 46.9C92.7 36.1 95.4 21.1 106.2 13.5L119.3 4.3C130.2-3.3 145.2-0.6 152.8 10.2L203.8 82.9C230.7 75.8 258.9 72 288 72 407.8 72 513 135.9 569.4 231.6A48-48 0 0 0 569.4 280.4zM424 256C424 180.8 363.2 120 288 120 270.1 120 252.9 123.5 237.3 129.8L256.6 156.8C282.4 148.7 311.6 150.7 337 164.2H336.9C313.3 164.2 294.1 183.4 294.1 207.1 294.1 230.7 313.3 249.9 336.9 249.9 360.6 249.9 379.8 230.7 379.8 207.1V207C398.2 241.5 396.1 284.9 371.5 318V318L390.8 345.1C411.5 321.2 424 290.1 424 256zM262 356.7L184.5 246C179.5 298.4 213.8 344.3 262 356.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/eye-slash.js
// module id = JQCr
// module chunks = 144